/**
 * Escape `string` for a regular expression to match literal text.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
 *
 * @param {string} string
 * @returns {string} escaped string that can safely be interpolated into a RegExp.
 */
export default function escapeRegExp(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
